// extracted by mini-css-extract-plugin
module.exports = {"tab":"roles-tab_tab__1jwEj"};